<template>
  <!-- 代投订单 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3" :class="{'close':!searchMore}">
        <div class="input-item select-two">
          <Select v-model="searchParams.dateType" :transfer="true">
            <Option value="1">支付时间</Option>
            <Option value="2">创建时间</Option>
          </Select>
          <DatePicker type="daterange" split-panels separator="至" :transfer="true" placement="bottom"
            format="yyyy-MM-dd" placeholder="选择日期"
            @on-change="searchParams.date=$event" ></DatePicker>
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">订单状态</span>
          <Select v-model="searchParams.payStatus" :transfer="true" clearable>
            <Option value="1">未支付</Option>
            <Option value="2">已付款</Option>
            <Option value="3">已退款</Option>
            <Option value="4">已失效</Option>
          </Select>
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.userType" :transfer="true">
            <Option value="1">投保人</Option>
            <Option value="2">被保险人</Option>
          </Select>
          <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
        </div>
        <div class="input-item">
          <span class="label">订单号</span>
          <Input v-model="searchParams.orderNo" placeholder="请输入" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost v-if="searchMore" @click="searchMore=false">收起<Icon type="ios-arrow-up" /></Button>
          <Button type="primary" ghost v-else @click="searchMore=true">展开<Icon type="ios-arrow-down" /></Button>
        </div>
      </div>
      <Tabs
        v-model="searchParams.firstTab"
        v-if="userInfo.userType!=4"
        :animated="false"
        @on-click="toggleFirstTab"
      >
        <TabPane label="全部订单" name="1"></TabPane>
        <TabPane label="直属团队订单" name="2"></TabPane>
        <TabPane label="下级机构订单" name="3"></TabPane>
      </Tabs>
      <div class="sedTab" v-if="isShowSed">
        <ul class="filterTab">
          <li
            :class="{active:curActive==index}"
            v-for="(item,index) in sendTab"
            :key="index"
            @click="toggleSecondTab(index,item)"
          >{{item.label}}</li>
        </ul>
      </div>
      <div class="table-box setTable">
        <loading :isShow="$root.$children[0].isShowLoading" />
        <Table :columns="columns" :data="tableDate">
          <template slot-scope="{ row, index }" slot="bar">
            <div class="detail">
              <div @click="showDetail(row)">详情</div>
              <div @click="copyLink(row.insureUrl)" v-if="!row.status">复制代投链接</div>
              <div
                @click="copyLink(row.payUrl, true)"
                v-show="row.status==1&&(row.checkInsuranceStatus!=3&&row.checkInsuranceStatus!=4&&row.checkInsuranceStatus!=2)"
              >
                获取支付链接
              </div>
            </div>
          </template>
        </Table>
      </div>
      <div class="pageBox">
        <Page
          :total="total"
          :current="searchParams.pageNo"
          :page-size="searchParams.pageSize"
          show-total
          @on-change="pageChange"
          style="text-align: center"
        />
      </div>
    </div>
    <!-- 订单详情  -->
    <Modal
      v-model="showOrderdetail"
      title="订单详情"
      @on-ok="confirmAddOrderDetail"
      :footer-hide="true"
      @on-cancel="cancelOrderDetail"
      width="1200"
      class="my-modal"
    >
      <Tabs :value="type" :animated="false" style="padding-top: 10px">
        <TabPane label="投保信息" name="1">
          <my-form :formList="insurebase" :span="8" class="detail"></my-form>
        </TabPane>
        <TabPane label="被保险人及保障权益" name="2">
          <interests :obj="detailInfo" />
        </TabPane>
      </Tabs>
    </Modal>
  </div>
</template>

<script>
import myForm from "@/components/commons/form";
import interests from "./components/interests";
import insurebase from "./form/insurebase";
import renewal from "./components/renewal";
import record from "./components/record";
import filter from "@/api/filter";
import { mapState } from "vuex";
import _ from "lodash";
import {pageTool} from "@/api/mixins";
import selectTree from "@/components/system/selectTree";
import {
  getOrdeDetail,
  orderExportAll
} from "@/api/httpList";
export default {
  mixins:[pageTool],
  components: {
    selectTree,
    myForm,
    interests,
    renewal,
    record
  },
  props: {},
  data() {
    return {
      isShowTxt: false,
      detailInfo: {},
      type: "1",
      cur: 0,
      countObj: {},
      curActive: 0,
      total: 0,
      //过滤项
      searchParams: {
        dateType:'2',
        userType:'1',
        pageNo:1,
        pageSize:10,
      },
      sendTabbase: [
        {
          label: "全部",
          value: "1"
        },
        {
          label: "待支付",
          value: "6"
        },
        {
          label: "人工核保中",
          value: "2"
        },
        {
          label: "核保失败",
          value: "3"
        },
        {
          label: "已撤单",
          value: "4"
        }
      ],
      sendTabother: [
        {
          label: "全部",
          value: "1"
        },
        {
          label: "有部分退款",
          value: "5"
        }
      ],
      isShowSed: false,
      sendTab: [],
      insurebase: [], //投保信息
      firstTab: "1", //一级tab
      showOrderdetail: false,
      columns: [],
      tableDate: []
    };
  },
  watch: {
    payStatus(value) {
      if (value == 1) {
        this.sendTab = _.cloneDeep(this.sendTabbase);
        this.isShowSed = true;
        this.isShowTxt = false;
      } else if (value == 2) {
        this.sendTab = _.cloneDeep(this.sendTabother);
        this.isShowTxt = false;
        this.isShowSed = true;
      } else if (value == 4) {
        this.isShowTxt = true;
      } else {
        this.isShowSed = false;
        this.isShowTxt = false;
      }
      this.curActive = 0;
      this.searchParams.secondTab = ""; //复位二级tab
      this.getOrder();
    }
  },
  computed: {
    ...mapState(["userInfo"]),
    payStatus() {
      return this.searchParams.payStatus
    }
  },
  methods: {
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {//机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = "";
      } else if (data.nodeType == 2) {//团队
        this.searchParams.orgId = "";
        this.searchParams.groupId = data.id;
      }else{
        this.searchParams.orgId = "";
        this.searchParams.groupId = "";
      }
    },
    async exportList() {
      const params = this.initFilterObj();
      const res = await orderExportAll(params);
      const fileName = decodeURI(
        res.headers["content-disposition"].split(";")[1].split("filename=")[1]
      );
      const blob = new Blob([res.data]); //构造一个blob对象来处理数据
      // const fileName = "xx.xls";
      //对于<a>标签，只有 Firefox 和 Chrome（内核） 支持 download 属性
      //IE10以上支持blob但是依然不支持download
      if ("download" in document.createElement("a")) {
        //支持a标签download的浏览器
        const link = document.createElement("a"); //创建a标签
        link.download = fileName; //a标签添加属性
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        document.body.appendChild(link);
        link.click(); //执行下载
        URL.revokeObjectURL(link.href); //释放url
        document.body.removeChild(link); //释放标签
      } else {
        //其他浏览器
        navigator.msSaveBlob(blob, fileName);
      }
      this.$Message.success("导出成功");
    },
    getPayLink(index) {
      const target = document.querySelectorAll(".payUrl_target");
      target[index].select();
      document.execCommand("Copy");
      this.$Message.success("订单支付链接复制成功，请在移动端打开支付");
    },
    //切换一级tab
    async toggleFirstTab() {
      if (this.searchParams.firstTab === this.copyFirstTab) return;
      this.curActive = 0;
      this.searchParams.secondTab = "1"; //复位二级tab
      this.searchParams.pageNo = 1;
      this.getOrder();
    },
    async toggleSecondTab(index, item) {
      this.curActive = index;
      this.searchParams.secondTab = item.value;
      if (this.searchParams.secondTab === this.copySecondTab) return;
      this.searchParams.pageNo = 1;
      this.getOrder();
    },
    pageChange(pageNo) {
      this.searchParams.pageNo = pageNo;
      this.getOrder();
    },
    resetSearch(){
      this.searchParams = {
        dateType:'2',
        userType:'1',
        pageNo:1,
        pageSize:10,
        firstTab:'1',
        secondTab:'1',
      }
      this.searchAjax();
    },
    //搜索
    searchAjax() {
      this.searchParams.pageNo = 1;
      this.$root.$children[0].isShowLoading = true;
      this.getOrder();
    },
    //获取订单
    async getOrder() {
      const params = this.initFilterObj();
      this.copyFirstTab = params.firstTab; //备份
      this.copySecondTab = params.secondTab;
      this.$root.$children[0].isShowLoading = true;
      this.$http({
        url: "/buz/orderImport/read/list",
        type: "POST",
        data: params
      }).then(res => {
        this.tableDate = res.data;
        this.total = res.total;
        this.$root.$children[0].isShowLoading = false;
      }).catch(() => {
        this.$root.$children[0].isShowLoading = false;
      });
    },
    // 复制链接
    copyLink(url){
      if(!url) {
        this.$notice.msg('链接不存在');
        return;
      }
      if(isPay) {
        this.$units.copyUrl(url, false, false);
        this.$notice.success('订单支付链接复制成功，请在移动端打开支付');
      }else{
        this.$units.copyUrl(url, true);
      }
    },
    async showDetail(row) {
      if(!row.status) {//录入数据
        window.open(row.insureUrl);
        return;
      }
      this.showOrderdetail = true;
      const res = await getOrdeDetail(row.orderNo);

      const obj = {
        orgName: row.orgName,
        groupName: row.groupName,
        salesmanName: row.salesmanName
      };
      this.detailInfo = Object.assign(res.data, obj);
      //回填基本信息
      this.insurebase = insurebase(this, row.status, this.detailInfo, row);
      this.insurebase[0].data.forEach(item => {
        for (let key in res.data) {
          if (item.key == key) {
            item.value = res.data[key];
          }
          if (!item.value) {
            item.value = "-";
          }
        }
      });
      //投保人信息
      this.insurebase[1].data.forEach(item => {
        for (let key in res.data.holder) {
          if (item.key == key) {
            item.value = res.data.holder[key];
          }
        }
      });
    },
    confirmAddOrderDetail() {},
    cancelOrderDetail() {},
    //获取最新搜索条件
    initFilterObj() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      if(params.date&&params.date[0]){
        if(params.dateType == 1){//支付时间
          params.payTimeStart = params.date[0];
          params.payTimeEnd = params.date[1];
        }else if(params.dateType == 2){//创建时间
          params.createTimeStart = params.date[0];
          params.createTimeEnd = params.date[1];
        }
      }
      delete params.dateType;
      delete params.date;
      if(params.userType == 1){//投保人
        params.holderName = params.name;
      }else if(params.userType == 2){//被保险人
        params.insuranceName = params.name;
      }
      delete params.userType;
      delete params.name;
      
      delete params.applyOrgId;
      return params;
    },
  },
  created() {},
  async mounted() {
    const vm = this;
    this.columns = [
      {
        title: "订单号",
        key: "orderNo",
        align: "center",
        width:230,
      },

      {
        title: "所属团队",
        key: "groupName",
        align: "center",
        minWidth:200,
        render(h, params) {
          const res =
            params.row.groupName
              ? (params.row.orgName + "/" + params.row.groupName)
              : params.row.orgName;
          return (
            <div class="ivu-table-cell-ellipsis" style="display:block">
              <Tooltip style="width:100%" content={res}>
                <span class="ivu-table-cell-tooltip-content">{res}</span>
              </Tooltip>
            </div>
          );
        }
      },
      {
        title: "所属业务员",
        key: "salesmanName",
        align: "center",
        minWidth:160,
        tooltip:true
      },
      {
        title: "产品名称",
        width:230,
        key: "productName",
        align: "center",
      },
      {
        title: "投/被保险人",
        key: "holderName",
        align: "center",
        minWidth:160,
        tooltip:true,
        render(h, params) {
          if (params.row.insuranceName) {
            const res = params.row.holderName + "/" + params.row.insuranceName;
            return <span>{res}</span>;
          } else {
            const res = params.row.holderName;
            return <span>{res}</span>;
          }
        }
      },

      {
        title: "保费（元）",
        key: "fee",
        align: "center",
        minWidth:120,
        tooltip:true
      },
      {
        title: "订单状态",
        key: "status",
        align: "center",
        minWidth:120,
        tooltip:true,
        // render(h, params) {
        //   const value = filter.filterOrderStatus(params.row.status);
        //   return <span>{value}</span>;
        // },
        render(h, params) {
          let value = "";
          // ['1', "未支付"],
          // ['2', "已付款"],
          // ['3', "已退款"],
          // ['4', "已失效"],
          const payStatus = params.row.status||"-1";
          const checkStaus = +params.row.checkInsuranceStatus;
          const result = filter.filterOrderStatus(payStatus);
          // 1 核保成功 2 人工核保中 3 核保失败 4 已撤单
          if (payStatus != 1) {
            value = result;
          } else {
            const arr = ["核保成功", "人工核保中", "核保失败", "已撤单"];
            if (checkStaus == 1) {
              value = "未支付";
            } else if(checkStaus) {
              const other = arr[checkStaus - 1];
              value = result + "-" + other;
            }else{
              value = result
            }
          }

          return <span>{value}</span>;
        }
      },
      {
        title: "创建时间",
        key: "createTime",
        align: "center",
        tooltip: true,
        width:160,
        render(h, params) {
          const time = filter.filterTime(
            params.row.createTime,
            "YYYY-MM-DD HH:mm"
          );
          return <span>{time}</span>;
        }
      },
      {
        title: "操作",
        slot: "bar",
        align: "center",
        width:180,
        fixed:'right'
      }
    ];
    this.getOrder();
  }
};
</script>
<style lang="scss" scoped>
/deep/ .formGroup:after {
  display: none;
}

/deep/ .ivu-form-item-content {
  color: #272933;
}

/deep/ .ivu-modal-body {
  padding: 16px 30px;
}

.my-modal /deep/ .formGroup {
  position: relative;
  padding: 0;
  &:after {
    position: absolute;
    bottom: -5px;
    width: 100%;
    height: 20px;
    content: "";
    filter: blur(5px);
    background: #fff;
  }
}
.my-modal /deep/ .title {
  width: 100%;
  padding-bottom: 10px;
  padding-top: 10px;
  font-size: 14px;
  color: #3C464F;
  font-weight: bold;
  position: relative;
  display: flex;
  align-items: center;
  white-space: nowrap;
  height: 40px;
  &::before{
    content: "";
    display: block;
    width: 3px;
    height: 12px;
    background-color: #236DFF;
    margin-right: 6px;
  }
  &::after {
    content: "";
    display: block;
    background-color: #EFF3FC;
    height: 1px;
    width: 100%;
    margin-left: 10px;
  }
}

@import "./order.scss";

.myFormStyle /deep/ .selectStyle .ivu-select-selection {
  background-color: #f8f8f9;
}
</style>
